import { useQuery } from '@apollo/client';
import React, { memo, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import GET_CURRENT_TENANT from 'api/queries/GET_CURRENT_TENANT';
import Input from 'layout/atoms/Input/Input';
import Label from 'layout/atoms/Label';
import Modal from 'layout/atoms/Modal/Modal';
import FormField from 'layout/molecules/FormField/FormField';
import FormSaveActions from 'layout/molecules/FormSaveActions/FormSaveActions';
import { closeModal, selectModalByName } from 'store/layoutSlice';
import { addSeason, selectSeasonById, updateSeason } from 'store/parameters/seasonsSlice';
import useSeasonValidation from './useSeasonValidation';
function SeasonEditor({ create = false }) {
    var _a, _b, _c;
    const dispatch = useDispatch();
    const seasonId = (_a = useSelector(selectModalByName(create ? 'seasonCreator' : 'seasonEditor'))) === null || _a === void 0 ? void 0 : _a.id;
    const seasonDetails = useSelector((state) => selectSeasonById(state, seasonId || '')) || null;
    const { t } = useTranslation(['specification', 'common']);
    const { data: tenant } = useQuery(GET_CURRENT_TENANT);
    const tenantId = (_c = (_b = tenant === null || tenant === void 0 ? void 0 : tenant.me) === null || _b === void 0 ? void 0 : _b.currentTenant) === null || _c === void 0 ? void 0 : _c.id;
    const [formValues, setFormValues] = useState({
        name: '',
    });
    const { errors, isValid, pendingFields, markTouched, validateAll } = useSeasonValidation(formValues, t);
    useEffect(() => {
        if (!create && seasonDetails) {
            setFormValues({
                name: seasonDetails.name,
            });
        }
    }, [create, seasonDetails, seasonId]);
    const handleFormChange = ({ target: { name, value }, }) => {
        setFormValues((values) => (Object.assign(Object.assign({}, values), { [name]: value })));
    };
    const handleCancel = () => {
        dispatch(closeModal({ name: create ? 'seasonCreator' : 'seasonEditor' }));
    };
    const handleFormSubmit = () => {
        if (!validateAll())
            return;
        if (create) {
            dispatch(addSeason({ tenantId, name: formValues.name }));
        }
        else {
            dispatch(updateSeason({ seasonId: seasonDetails.id, name: formValues.name }));
        }
        dispatch(closeModal({ name: create ? 'seasonCreator' : 'seasonEditor' }));
    };
    return (React.createElement(Modal, { name: create ? 'seasonCreator' : 'seasonEditor', size: "s", header: React.createElement(Label, { weight: "strong" }, create ? t('add_season') : t('edit_season')), footer: React.createElement(FormSaveActions, { isValid: isValid, isLoading: false, pendingFields: pendingFields, onSave: handleFormSubmit, onCancel: handleCancel, validateAll: validateAll }), onClose: handleCancel },
        React.createElement(FormField, { label: t('common:name'), error: errors.name },
            React.createElement(Input, { value: formValues === null || formValues === void 0 ? void 0 : formValues.name, onChange: handleFormChange, onBlur: () => markTouched('name'), name: "name", error: Boolean(errors.name), autoFocus: true }))));
}
export default memo(SeasonEditor);
